<script setup lang="ts"></script>

<template>
    <div class="co-w-6 co-h-6 co-flex co-justify-center co-items-center co-rounded-full co-font-bold co-text-lg co-italic co-font-serif co-text-white co-bg-light-blue co-select-none co-cursor-pointer">
      i
    </div>
</template>

